import { SagaIterator } from 'redux-saga';
import { call, put } from 'redux-saga/effects';

import { Messages } from '../../../../codegen/Localize';
import { DatasourceDefinition, FlowDefinition, WorkbookDefinition } from '../../../../ts/models/ContentDefinitions';
import { FlowDetailInfo } from '../../../../ts/models/FlowInfo';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { IDataSourceDetailInfo } from '../../../../ts/models/IDataSourceInfo';
import { IWorkbookDetailInfo } from '../../../../ts/models/IWorkbookInfo';
import { DownloadActions } from '../../../../ts/services/DownloadActions';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { DownloadAction } from '../../../actions/spaces/DownloadAction';
import { ServiceLocator } from '../../../ServiceLocator';
import { getCorrectEntityIdForActions } from '../SpacesSagaHelpers';

export function* processDownload(action: DownloadAction): SagaIterator {
  try {
    // TODO (fix someday): Hack because getDatasource API called in the download function takes a data connection id
    const entityId = yield call(getCorrectEntityIdForActions, action.item.contentType, action.item.id);
    yield call(downloadContent, { ...action.item, id: entityId });
  } catch(e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function downloadContent(
  item: IContentInfo
): ng.IPromise<IWorkbookDetailInfo | IDataSourceDetailInfo | FlowDetailInfo> {
  const downloadService = ServiceLocator.get<DownloadActions>('DownloadActions');
  if (item.contentType === WorkbookDefinition.contentType) {
    return downloadService.downloadWorkbook(item);
  } else if (item.contentType === DatasourceDefinition.contentType) {
    return downloadService.downloadDatasource(item);
  } else if (item.contentType === FlowDefinition.contentType) {
    return downloadService.downloadFlow(item);
  }
}
